<template>
  <section class="messages-section simple-filter">
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <div class="top-bar">
      <CaseMessagesNavigation />
    </div>
    <div class="filter-content">
      <div class="nav-chat">
        <div class="dashboard-search">
          <GreySearchIcon24 />
          <input
            id="case-apps-search"
            v-model="contactSearchModel"
            class="search"
            type="text"
            placeholder="Search"
          >
        </div>
        <vue-custom-scrollbar
          v-if="contactList.length"
          :settings="settings"
          class="scroll-area"
        >
          <ul class="profile-nav">
            <li
              v-for="(item, index) in contactList"
              :id="`media_contact_item_${item.id}`"
              :key="item.id + index"
            >
              <div
                class="holder-contacts"
                :class="{'active': item.id === currentPublicId && currentDeviceId === ''}"
                @click.stop="changeContact(item.id)"
              >
                <div class="contacts-name">
                  <div class="img-item">
                    <img
                      v-if="item.avatar"
                      :src="item.avatar"
                      alt="avatar"
                    >
                    <BlueUserIcon24 />
                  </div>
                  <span class="span-name">{{ item.name }}</span>
                </div>
                <div
                  class="message-time"
                  v-text="parseDate(Date.parse(item.date)) === '-' ? '' : parseDate(Date.parse(item.date))"
                />
              </div>
              <!--              <ul class="profile-item-devices">-->
              <!--                <li-->
              <!--                  v-for="(device) in item.clientDevices"-->
              <!--                  :key="device.id"-->
              <!--                  :class="{'active': device.id === currentDeviceId}"-->
              <!--                  @click.stop="changeContactDevice(item, device)"-->
              <!--                >-->
              <!--                  <span>{{ getDeviceName(device) }}</span>-->
              <!--                </li>-->
              <!--              </ul>-->
            </li>
          </ul>
        </vue-custom-scrollbar>
        <div v-else class="empty-chats-wrap">
          <span>No results</span>
        </div>
      </div>
      <div class="chat-list" :class="{ disabled: isLoading }">
        <infinite-loading
          v-if="currentPublicId"
          ref="mediaScrollWrapper"
          direction="bottom"
          :identifier="infiniteId"
          @infinite="getMediaList"
        >
          <div slot="spinner">
            Loading...
          </div>
          <div slot="no-more">
            No more media
          </div>
          <div slot="no-results">
            <div class="no-media">
              <MediaEmptyStateIcon />
              <span>No media</span>
            </div>
          </div>
        </infinite-loading>
        <div v-else class="no-media">
          <MediaEmptyStateIcon />
          <span>No media</span>
        </div>
        <div class="attachment-wrapper">
          <gallery-item
            v-for="(item) in displayedPinnedMediaList"
            :id="`media-attachment_id-${createUniqKey(item.uniqKey)}`"
            :key="item.uniqKey"
            class="attachment-media"
            :attachment="item"
            @changeCheckbox="changeAttachmentCheckbox"
            @exportItem="openExportPopup"
            @updateMedia="updateMedia"
            @openMediaPopup="openMediaPopup"
          />
        </div>
        <div class="attachment-wrapper">
          <gallery-item
            v-for="(item) in displayedMediaList"
            :id="`media-attachment_id-${createUniqKey(item.uniqKey)}`"
            :key="item.uniqKey"
            class="attachment-media"
            :attachment="item"
            @changeCheckbox="changeAttachmentCheckbox"
            @exportItem="openExportPopup"
            @updateMedia="updateMedia"
            @openMediaPopup="openMediaPopup"
          />
        </div>
        <SelectedMessagesInfo
          :messages="[...displayedMediaList, ...displayedPinnedMediaList]"
          :selected-messages-id="selectedAttachmentsIds"
          @updatedActiveStatus="updatedActiveStatus($event)"
          @exportMedia="openExportPopup"
          @selectedFormat="format = $event"
          @pinMarked="pinMarked"
        />
      </div>
    </div>
    <CommonDialog
      ref="progressDialog"
      :show-footer="false"
      :closable="false"
    >
      <h2 class="dialog-message-title">
        Exporting media
      </h2>
      <p class="dialog-create-description" style="display:block; font-size: 14px;">
        Please wait a bit. The media is being
        exported.
      </p>
      <div class="loader-p" />
    </CommonDialog>
    <SuccessPopup
      ref="successPopup"
      text="A URL will be sent to your email with a download link. Do not share this link."
    />
    <ExportPopup
      ref="exportPopup"
      :is-filters-applied="false"
      :is-messages-export="false"
      @export="exportMedia"
    />
    <MediaItemPopup
      ref="mediaItemPopup"
      :attachment="currentAttachment"
      :attachment-type="currentAttachmentType"
      :tags-list="currentTagsList"
      :unblurred-link="unblurredLink"
      :gallery-items="galleryItems"
      :current-index="currentIndex"
      @closed="unblurredLink = ''"
      @resetUnblurred="unblurredLink = ''"
      @menuOptionSelect="handleMenuOptionSelect"
      @showOriginContent="showOriginContent"
      @pageChanged="handlePageChanged"
    />
    <MetadataPopup ref="metadataPopup" :file-metadata="fileMetadata" />
  </section>
</template>

<script>

import InfiniteLoading from 'vue-infinite-loading';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import settings from '@/mixins/scrollSettings';
import GalleryItem from '@/components/cases/case-messages/media/GalleryItem.vue';
import parseDate from '@/mixins/parseDate';
import SelectedMessagesInfo from '@/components/selected-messages-info/SelectedMessagesInfo.vue';
import SuccessPopup from '@/components/popups/SuccessPopup.vue';
import CaseMessagesNavigation from '@/components/cases/case-messages/CaseMessagesNavigation.vue';
import CommonDialog from '@/components/popups/CommonDialog.vue';
import AlertErrorMsg from '@/components/profile/AlertErrorMsg.vue';
import streamReader from '@/mixins/streamReader';
import ExportPopup from '@/components/popups/ExportPopup.vue';
import {mapActions, mapGetters} from 'vuex';
import mediaTagging from '@/mixins/mediaTagging';
import GreySearchIcon24 from '@/components/icons/GreySearchIcon24.vue';
import BlueUserIcon24 from '@/components/icons/BlueUserIcon24.vue';
import MediaEmptyStateIcon from '@/components/icons/MediaEmptyStateIcon.vue';
import MediaItemPopup from '@/components/popups/MediaItemPopup.vue';
import MetadataPopup from '@/components/popups/MetadataPopup.vue';

export default {
  name: 'CaseMessagesMedia',
  components: {
    MediaEmptyStateIcon,
    BlueUserIcon24,
    GreySearchIcon24,
    ExportPopup,
    AlertErrorMsg,
    CommonDialog,
    CaseMessagesNavigation,
    SuccessPopup,
    SelectedMessagesInfo,
    GalleryItem,
    InfiniteLoading,
    vueCustomScrollbar,
    MediaItemPopup,
    MetadataPopup,
  },
  emits: ['show-error'],
  mixins: [settings, parseDate, streamReader, mediaTagging],
  data() {
    return {
      errorMessage: '',
      caseId: this.$route.params.slug,
      currentPublicId: '',
      currentDeviceId: '',
      contactList: [],
      displayedMediaList: [],
      displayedPinnedMediaList: [],
      allMediaItems: [],
      contactSearchModel: '',
      infiniteId: +new Date(),
      currentAttachment: {},
      currentAttachmentType: '',
      currentTagsList: [],
      unblurredLink: '',
      galleryItems: [],
      currentIndex: 0,
      mediaPage: 1,
      mediaPageSize: 20,
      selectedAttachmentsIds: [],
      isCheckedAllAttachments: false,
      format: '',
      fileMetadata: null,
    };
  },
  computed: {
    ...mapGetters('mediaTagging', ['isLoading']),
  },
  watch: {
    currentPublicId(newVal) {
      if (newVal && newVal !== this.$route.query.publicId) {
        this.setClientId(newVal);
        this.updateMedia();
        this.$router.replace({query: {publicId: newVal}});
      }
    },
    contactSearchModel(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.debounce(this.getContactList, 300, 'search');
      }
    },
    currentDeviceId(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.updateMedia();
    }
  },
  mounted() {
    this.setTaggingMode(false);
    this.getContactList('mounted', this.$route.query.publicId);
  },
  methods: {
    ...mapActions('mediaTagging', [
      'setClientInfo',
      'setDeviceInfo',
      'setClientId',
      'setTaggingMode',
      'setInitialState',
      'setTaggingItem',
    ]),
    updateMedia() {
      this.mediaPage = 1;
      this.displayedMediaList = [];
      this.displayedPinnedMediaList = [];
      this.infiniteId += 1;
    },
    getContactList(flag = null, publicId = null) {
      this.$load(async () => {
        const res = await this.$api.cases.getCasesClients(this.caseId, {keySearch: this.contactSearchModel});
        this.contactList = res.data.body.content.map(i => {
          return {
            id: i.publicId,
            name: i.email,
            date: i.lastSyncDate,
            avatar: i.avatar,
            clientDevices: i.clientDevices
          };
        });

        if (flag === 'mounted') {
          this.currentPublicId = publicId || this.contactList[0].id;
          this.setClientId(publicId || this.contactList[0].id);
          this.setClientInfo(this.contactList[0]);
          this.setDeviceInfo(this.contactList[0].clientDevices[0]);
        }
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    changeContact(id) {
      this.currentDeviceId = '';
      if (id && id !== this.currentPublicId) {
        this.currentPublicId = id;
        this.updateMedia();
      }
    },
    changeContactDevice(contact, device) {
      if (device.id && device.id !== this.currentDeviceId) {
        if (contact.id !== this.currentPublicId) this.currentPublicId = contact.id;
        this.currentDeviceId = device.id;
        this.setDeviceInfo(device);
        this.setClientInfo(contact);
        this.updateMedia();
      }
    },
    getMediaList($state) {
      const params = {
        page: this.mediaPage,
        size: this.mediaPageSize,
        deviceId: this.currentDeviceId,
      };
      if (!this.currentPublicId) return;
      this.$load(async () => {
        const res = await this.$api.media.getGalleryListFiles(this.caseId, this.currentPublicId, params);
        let content = res.data.body.content.map((i) => {
          return {
            ...i,
            uniqKey: this.createUniqKey(i.id),
            id: i.id,
            link: i.link,
            name: i.name,
            type: i.contentType
          };
        });

        if (content.length) {

          this.mediaPage += 1;
          const reversedContent = content.reverse().map(item => ({...item, isActive: false}));
          const pinnedItems = reversedContent.filter(item => item.isPinned);
          this.displayedPinnedMediaList.unshift(...pinnedItems);
          const unpinnedItems = reversedContent.filter(item => !item.isPinned);
          this.displayedMediaList.unshift(...unpinnedItems);
          $state.loaded();
        } else {
          $state.complete();
        }

      }, (error) => {
        this.handleResponseError(error);
        $state.error();
      });
    },
    changeAttachmentCheckbox(item) {
      if (item.isActive) {
        this.selectedAttachmentsIds.push(item.id);
      } else {
        this.selectedAttachmentsIds = this.selectedAttachmentsIds.filter(id => id !== item.id);
      }
    },
    updatedActiveStatus($event) {
      const allUpdatedMessages = $event.messages;

      this.allMediaItems = [...allUpdatedMessages];

      this.displayedPinnedMediaList = allUpdatedMessages.filter(item => item.isPinned);

      this.displayedMediaList = allUpdatedMessages.filter(item => !item.isPinned);

      this.isCheckedAllAttachments = $event.isCheckedAllMessages;
      this.selectedAttachmentsIds = $event.selectedMessagesId;
    },
    openExportPopup(data) {
      this.selectedAttachmentsIds = Array.isArray(data) ? data : [data];
      // this.$refs.exportPopup.openPopups();
      this.exportMedia();
    },
    exportMedia() {
      this.$load(async () => {
        this.$refs.exportPopup.closePopups();
        this.$refs.progressDialog.openPopups();

        const response = await this.$api.media.exportGallery(
          this.caseId,
          this.format || 'csv',
          {galleryIds: this.selectedAttachmentsIds}
        );
        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 25);
        this.handleStreamResult();

        this.displayedMediaList = this.displayedMediaList.map(item => {
          if (this.selectedAttachmentsIds.includes(item.id)) {
            return {...item, isActive: false};
          }
          return item;
        });

        this.displayedPinnedMediaList = this.displayedPinnedMediaList.map(item => {
          if (this.selectedAttachmentsIds.includes(item.id)) {
            return {...item, isActive: false};
          }
          return item;
        });

        this.selectedAttachmentsIds = [];

        this.$refs.successPopup.openPopup();
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    exportMediaV2(selectedIds) {
      this.$load(async () => {
        this.$refs.progressDialog.openPopups();

        const response = await this.$api.caseExport.exportCaseItems(this.caseId, 'media', this.format, selectedIds);
        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 25);
        this.handleStreamResult();

        // Deactivate checkboxes for exported items
        this.displayedMediaList = this.displayedMediaList.map(item => {
          if (selectedIds.includes(item.id)) {
            return {...item, isActive: false};
          }
          return item;
        });

        this.displayedPinnedMediaList = this.displayedPinnedMediaList.map(item => {
          if (selectedIds.includes(item.id)) {
            return {...item, isActive: false};
          }
          return item;
        });

        // Clear selected IDs if they match the exported IDs
        if (JSON.stringify(this.selectedAttachmentsIds.sort()) === JSON.stringify(selectedIds.sort())) {
          this.selectedAttachmentsIds = [];
        }

        this.$refs.successPopup.openPopup();
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    getDeviceName(device) {
      if (typeof device === 'string') return device;
      if (device.os && device.osVersion) {
        return device.os + ' ' + device.osVersion;
      } else if (device.os) {
        return device.os;
      }
      return 'Unknown device';
    },
    async pinMarked(galleryIds) {
      const mediaArrayByIds = [
        ...this.displayedMediaList.filter(item => galleryIds.includes(item.id)),
        ...this.displayedPinnedMediaList.filter(item => galleryIds.includes(item.id))
      ];
      const pinnedItems = mediaArrayByIds.filter(item => item.isPinned);

      if (pinnedItems.length === galleryIds.length) {
        await this.unPinGallery(galleryIds);
      } else if (pinnedItems.length > 0 || pinnedItems.length < 1) {
        const resultIdsArray = mediaArrayByIds.filter(item => !item.isPinned).map(item => item.id);
        await this.pinGallery(resultIdsArray);
      }
      this.selectedAttachmentsIds = [];
      this.updateMedia();
    },
    openMediaPopup(itemId, options = {}) {
      const allGalleryItems = [...this.displayedPinnedMediaList, ...this.displayedMediaList];
      const currentIndex = allGalleryItems.findIndex(item => item.id === itemId);
      if (currentIndex !== -1) {
        this.galleryItems = allGalleryItems;
        this.currentIndex = currentIndex;
        this.currentAttachment = allGalleryItems[currentIndex];

        if (options && options.jpegUrl) {
          this.currentAttachment = {
            ...this.currentAttachment,
            convertedJpegUrl: options.jpegUrl
          };
        }

        this.currentAttachmentType = this.currentAttachment.type
          ? this.currentAttachment.type.split('/')[0].toLowerCase()
          : this.getFileType(this.currentAttachment.name);
        this.currentTagsList = this.currentAttachment.tags || [];

        this.$refs.mediaItemPopup.openPopups();
      }
    },

    updateAttachmentInPopup() {
      this.$load(async () => {
        const response = await this.$api.media.getGalleryById(
          this.caseId,
          this.$route.query.publicId,
          this.currentAttachment.id
        );
        this.currentAttachment = response.data.body;
        this.currentTagsList = this.currentAttachment.tags || [];

        const index = this.galleryItems.findIndex(item => item.id === this.currentAttachment.id);
        if (index !== -1) {
          this.$set(this.galleryItems, index, this.currentAttachment);
        }
      }, (error) => {
        this.handleResponseError(error);
      });
    },

    getFileType(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();

      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'heic', 'heif'];
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv'];

      if (imageExtensions.includes(extension)) {
        return 'image';
      } else if (videoExtensions.includes(extension)) {
        return 'video';
      } else {
        return 'other';
      }
    },

    handleMenuOptionSelect(optionName) {
      switch (optionName.toLocaleLowerCase()) {
        case 'export':
          this.openExportPopup(this.currentAttachment.id);
          break;
        case 'mark priority':
        case 'remove from priorities':
          if (!this.currentAttachment.isPinned) {
            this.pinGallery([this.currentAttachment.id]).then(() => {
              this.updateAttachmentInPopup();
            });
          } else {
            this.unPinGallery([this.currentAttachment.id]).then(() => {
              this.updateAttachmentInPopup();
            });
          }
          this.updateMedia();
          break;
        case 'redact media':
        case 'unredact media':
          if (!this.currentAttachment.isBlured) {
            // Clear unblurred link when blurring the image
            this.unblurredLink = '';
            this.blurGallery(this.currentAttachment.id).then(() => {
              this.updateAttachmentInPopup();
            });
          } else {
            this.unBlurGallery(this.currentAttachment.id).then(() => {
              this.updateAttachmentInPopup();
            });
          }
          this.updateMedia();
          break;
        case 'show meta':
          this.openMetadataPopup();
          this.$refs.mediaItemPopup.closePopups();
          break;
        case 'view details':
          this.gotoTagging();
          this.$refs.mediaItemPopup.closePopups();
          break;
      }
    },

    async showOriginContent(galleryId) {
      await this.showBluredGallery(galleryId);
    },

    handlePageChanged(data) {
      this.currentIndex = data.index;
      this.currentAttachment = this.galleryItems[data.index];
      this.currentTagsList = this.currentAttachment.tags || [];
      this.currentAttachmentType = this.currentAttachment.type
        ? this.currentAttachment.type.split('/')[0].toLowerCase()
        : this.getFileType(this.currentAttachment.name);
    },

    openMetadataPopup() {
      this.$load(async () => {
        const response = await this.$api.media.getGalleryData({
          caseId: this.caseId,
          galleryId: this.currentAttachment.id
        });
        this.fileMetadata = response.data.body;
        this.$refs.metadataPopup.openPopups();
      }, (error) => {
        this.handleResponseError(error);
      });
    },

    gotoTagging() {
      if (this.isTaggingActive) {
        this.setTaggingItem(this.currentAttachment);
      } else {
        this.setInitialState({
          caseId: this.caseId,
          clientId: this.$route.query.publicId,
          taggingItem: this.currentAttachment,
        });
        if (this.$route.name !== 'Media tagging main tab') {
          this.$router.push({name: 'Media tagging main tab'});
        }
      }
    },
  }
};
</script>

<style scoped>
.messages-section {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 27px 55px 27px 35px;
}

.filter-content {
  display: flex;
  width: 100%;
  max-height: 90.7vh;
}

.nav-chat {
  padding-top: 120px;
  width: 381px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #D7DCE6;
}

.simple-filter .top-bar {
  padding: 30px 24px;
}

.chat-list {
  width: 100%;
  overflow: auto;
  margin-top: 120px;
}

.section-no-found img {
  margin-bottom: 30px;
}

.section-no-found p {
  margin-bottom: 18px;
  font-size: 16px;
  font-weight: 500;
  color: var(--light-gray);
}

.top-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  padding: 15px 22px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  background: #FFFFFF;
  box-shadow: 0 4px 10px rgba(77, 106, 147, 0.15);
}

.advanced-filter .top-bar {
  position: static;
  width: 100%;
}

.img-item {
  width: 32px;
  height: 32px;
  overflow: hidden;
  border: 1px solid var(--white-color);
  border-radius: 50%;
}

.empty-chats-wrap {
  text-align: center;
  margin-top: 45px;
}

label {
  display: block;
  margin-bottom: 5px;
}

.tab-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-width: 310px;
  width: 100%;
  min-height: 35px;
  margin-right: 20px;
  border-radius: 79px;
  border: 1px solid var(--case-btn-border-color);
}

.tab-btn {
  margin: -1px 0 -1px 0;
  width: 50%;
  max-height: 35px;
  padding: 10px 30px;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
  border-radius: 79px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  transition: 0.3s all;
}

.tab-btn.active {
  border-color: var(--accent-color);
}

.tab-btn-text {
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  color: var(--light-gray);
  transition: 0.3s all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-btn.active .tab-btn-text,
.tab-btn:hover .tab-btn-text {
  color: var(--accent-color);
}

.profile-nav {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin-top: 0;
  height: calc(700px + 130px)
}

.profile-nav li {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  transition: all .2s;
}

.profile-item-devices li {
  display: flex;
  color: var(--secondary-text-color);
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  margin: 0;
}

.profile-nav .profile-item-devices {
  width: 100%;
}

.profile-nav .profile-item-devices li {
  align-items: flex-start;
  padding: 17px 21px 17px 32px;
}

.contacts-name {
  width: calc(100% - 85px);
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.img-item {
  width: 24px;
  height: 24px;
  overflow: hidden;
  border: 1px solid var(--white-color);
  border-radius: 50%;
  margin-right: 8px;
}

.img-item img,
.img-item svg {
  width: 100%;
  height: 100%;
}

.img-item img {
  object-fit: cover;
}

.holder-contacts {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 21px;
}

.holder-contacts:hover,
.profile-item-devices li:hover {
  color: var(--secondary-black-color);
  background-color: rgba(28, 202, 205, 0.05);
}

.holder-contacts.active,
.profile-item-devices li.active {
  color: var(--secondary-black-color);
  background-color: rgba(28, 202, 205, 0.05);
}

.span-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--secondary-black-color);
}

.search {
  border-radius: 79px;
  border: 1px solid var(--input-placeholder-value-color);
  padding: 0 0 0 44px;
  height: 35px;
  width: 100%;
  outline: none;
}

.dashboard-search {
  position: relative;
  width: auto;
  margin: 0 10px 20px 20px;
}

.search::placeholder {
  color: var(--light-gray);
  font-size: 14px;
}

.dashboard-search svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
}

.attachment-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 20px 21px 50px 21px;
}

.attachment-media {
  margin-right: 8px;
  margin-bottom: 8px;
}

.message-time {
  text-align: right;
  font-weight: 500;
  font-size: 11px;
  line-height: 19px;
  color: var(--secondary-text-color);
  width: 75px;
  margin-left: 10px;
}

.no-media {
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 45px;
}

.no-media span {
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  text-align: center;
  color: var(--light-gray);
}

.dialog-message-title {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #292B2F;
  text-align: center;
  margin: 25px 0 0;
  display: block;
  width: 100%;
}

.dialog-create-description {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-align: center;
  color: var(--light-gray);
  margin: 10px 0 0;
}

.loader-p {
  width: 50px;
  height: 50px;
  position: relative;
  margin: 20px 40px 20px 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.4;
}

</style>
